module.exports = __webpack_public_path__ + "2c66831290bb23d86845392470ae97bc.png";